import { render, staticRenderFns } from "./peopleDetail.vue?vue&type=template&id=4c076348&"
import script from "./peopleDetail.vue?vue&type=script&lang=js&"
export * from "./peopleDetail.vue?vue&type=script&lang=js&"
import style0 from "./peopleDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports